/**
 * Ejecuta la multiplicación de todos los numeros pasados en entrada.
 * Devuelve el total calculado
 *
 * @param {array<float>} args: la lista de numeros a multiplicar
 *
 * @return {float} el total
 */

import { getMultiplicator } from './getMultiplicator';

export function mul(...args) {
  const multiplicator = getMultiplicator(args);
  const total = args.map(cur => cur * multiplicator).reduce((acc, cur) => acc * cur, 1);
  return total / Math.pow(multiplicator, args.length);
}
